module.exports = "/static/assets/0f37a12bb543f7559536071b670ffc9e.png";